module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eeuce"))).then(() => parcelRequire('1iHdE'));